export const Sources = {
  TPREK: 'tprek',
  LINKED: 'linked',
} as const;
